module.exports = __webpack_public_path__ + "static/media/redirecting-illustration.1817d7aa.svg";